<div class="container-fluid main-content d-flex align-items-center justify-content-center">
    <div class="h-100 w-100 row d-flex align-items-center justify-content-center">
        <div class="message" [ngClass]="(status=='1')?'success':'failed'">
            Payment {{(status=='1')?'Successful':'Failed'}}
        </div>
    </div>
</div>